//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import ImageBlurFallback from '../../Components/ImageBlurFallback';
import Image_png from '../../Assets/v2/home/Info.png';
import Image_webp from '../../Assets/v2/home/Info.webp';
import Image_fallback from '../../Assets/fallbacks/home/Info.jpg';

import HighlightInk from '../../Components/HighlightInk';

const InformationCard = () => {
  const { t } = useTranslation();
  return (
    <div className="information-card-container">
      <div className="information-card">
        <div className="information-card-left">
          <p>
            {t('infocardp1l1')}
            <HighlightInk> {t('infocardp1l2')} </HighlightInk>
            {t('infocardp1l3')}
            <HighlightInk> {t('infocardp1l4')} </HighlightInk>
            {t('infocardp1l5')}
            <HighlightInk> {t('infocardp1l6')} </HighlightInk>
            {t('infocardp1l7')}
            <HighlightInk> {t('infocardp1l8')} </HighlightInk>
            {t('infocardp1l9')}
            <br />
            <HighlightInk> {t('infocardp1l10')} </HighlightInk>
            .“
          </p>

          <p>
            {t('infocardp2l1')}
            <HighlightInk> {t('infocardp2l2')} </HighlightInk>
            {t('infocardp2l3')}
          </p>
        </div>

        <div className="information-card-right">
          <ImageBlurFallback
            className="information-card-right-img"
            fallbackImage={Image_fallback}
            webpImage={Image_webp}
            src={Image_png}
            alt="company info"
          />
        </div>
      </div>
    </div>
  );
};
export default InformationCard;



// WEBPACK FOOTER //
// ./src/Pages/Home/InformationCard.js